/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlacingTypeResponseDto
 */
export interface PlacingTypeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PlacingTypeResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PlacingTypeResponseDto
     */
    name: PlacingTypeResponseDtoNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PlacingTypeResponseDto
     */
    policyType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlacingTypeResponseDto
     */
    isActive: boolean;
}


/**
 * @export
 */
export const PlacingTypeResponseDtoNameEnum = {
    Facultative: 'Facultative',
    Treaty: 'Treaty',
    LineSlip: 'Line Slip',
    Retail: 'Retail',
    Wholesale: 'Wholesale'
} as const;
export type PlacingTypeResponseDtoNameEnum = typeof PlacingTypeResponseDtoNameEnum[keyof typeof PlacingTypeResponseDtoNameEnum];


/**
 * Check if a given object implements the PlacingTypeResponseDto interface.
 */
export function instanceOfPlacingTypeResponseDto(value: object): value is PlacingTypeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function PlacingTypeResponseDtoFromJSON(json: any): PlacingTypeResponseDto {
    return PlacingTypeResponseDtoFromJSONTyped(json, false);
}

export function PlacingTypeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlacingTypeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'policyType': json['policyType'] == null ? undefined : json['policyType'],
        'isActive': json['isActive'],
    };
}

export function PlacingTypeResponseDtoToJSON(json: any): PlacingTypeResponseDto {
    return PlacingTypeResponseDtoToJSONTyped(json, false);
}

export function PlacingTypeResponseDtoToJSONTyped(value?: PlacingTypeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'policyType': value['policyType'],
        'isActive': value['isActive'],
    };
}

